// extracted by mini-css-extract-plugin
module.exports = {"light":"pageWrapper_light__3TNcH","dark":"pageWrapper_dark__31V7L"};